import React from 'react';

const NumberDraw: React.FC = () => {
  return (
    <div>
      <h1 style={{ fontSize: 28, fontWeight: 500, margin: '0 0 8px' }}>번호 추첨</h1>
      <p style={{ margin: 0 }}>준비 중입니다...</p>
    </div>
  );
};

export default NumberDraw;
